import React from "react";

import { P, SectionHeading, SectionMainWrapper, SectionSmallHeading, SectionSubHeading, SectionWrapper, Text } from "../../Styles/style";

import arbscan from "../../../assets/images/ethscan.png"
import telegram from "../../../assets/images/telegram.png"
import uniswap from "../../../assets/images/uniswap.png"
import dextools from "../../../assets/images/dextools.png"
import twitter from "../../../assets/images/twitter.png"
import mainimg from "../../../assets/images/mainimg.png"
import styled from "@emotion/styled";
import { Container, Grid, useTheme } from "@mui/material";


const VideoBK = styled.img`
  height: calc( 100vh * 5);
  width: auto;
  transition: width 1s, height 1s;
`;

const ImageContainer = styled.div`
  height: 140vh;
  position:absolute;
  top:100px;
  right:0;
  z-index:1;
  overflow: hidden;
  max-width: calc( 33.333333% + 170px );
  width: 100%;
  display: flex;
  align-items: center;

  &:hover{
    img{
      width: auto;
      height: 35vh;
      transition: width 1s, height 1s;
      animation: bounce 1.5s;
    }
  }
  @keyframes bounce {
    0% {
      transform: scale(1); transform: translate(0%, 0%);
    }
    50% {
      transform: scale(0.1); transform: translate(0%, 0%);
    }
    100% {
      transform: scale(1); transform: translate(0%, 0%);
    }
  }
  
  @media screen and (max-width: 999px) {display: none;}
`
const GridHEading = styled(Grid)`
  padding: 50px 0 0;
  display: flex;
  align-items: center;
  @media screen and (max-width:599px){
    padding: 0px 0;
  }
`;
const GridVideo = styled(Grid)`
/* mix-blend-mode: lighten; */
`;
const Div = styled.div`
  padding:50px 0 20px;
 display:flex ;
 align-items:center;
 @media screen and (max-width:470px){
    display: block;

 }
`;
const GridImage = styled(Grid)`
padding: 50px 0;
/* place-content: ${(props) => (props.pc ? props.pc : "center")};
text-align: center; */
text-align: left;

@media screen and (max-width:599px){
  padding: 0px 0;
}
`;
const JOiningLinks = styled.img`
  /* width: 100%;
  max-width: ${(props) => (props.mw ? props.mw : "180PX")}; */
  margin-right: 10px;
  @media screen and (max-width:599px){
   /* max-width: ${(props) => (props.mw ? props.mw : "140PX")}; */

 }
`
const Arbspoan = styled.span`
  color: ${(props) => props.theme.textTertiary};
  font-size: ${(props) => props.fs ? props.fs : "calc(45px + (26 - 22) * ((100vw - 146px) / (1600 - 250)))"};
  font-family: "P-R";
  width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  padding: ${(props) => (props.p ? props.p : "10px 0")};
  text-align: ${(props) => (props.align ? props.align : "")};
  font-weight: 200;
  margin: ${(props) => (props.m ? props.m : "")};

  @media screen and (max-width: 972px) {
    font-size: ${(props) => props.fs ? props.fs : "calc(40px + (26 - 20) * ((100vw - 16px) / (1600 - 250)))"};
  }
  @media screen and (max-width: 419px) {
    font-size: ${(props) => props.fs ? props.fs : "calc(40px + (26 - 10) * ((100vw - 26px) / (1600 - 250)))"};
  }
`
const BuyNow = styled.a`
  text-decoration: none;
  background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.bgPrimary)};
  color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
  border-radius: 25px;
  padding: 10px 50px;
  margin-right: 15px;
  font-family:"Rockkb";
  @media screen and (max-width:499px){
    padding: 8px 25px;

  }

`
const Section1_Header = () => {
  const theme = useTheme()
  return (
    <SectionMainWrapper p="0rem 0" id="home">
      <Container maxWidth="xl">
        <GridHEading container >
          <GridImage xs={12} md={10} lg={8}>
            <SectionHeading
              p="20px 0 0PX"
              m="0"
              data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="400"
              data-aos-duration="600"
              data-aos-offset="0"
            >
             FEELS GOOD MAN!
            </SectionHeading>
           <SectionSmallHeading mw="40%" p="20px 0 40px">
           Who says good things can't come in small packages?
           </SectionSmallHeading>
            <div data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="700"
              data-aos-duration="500"
              data-aos-offset="0"
            >

              <BuyNow
                href=""
                target="_blank">
                Buy Now
              </BuyNow>
              <BuyNow 
                data-aos="flip-up"
                data-aos-easing="ease-in"
                data-aos-delay="700"
                data-aos-duration="700"
                data-aos-offset="0"
                href=""
                target="_blank">
                Chart
              </BuyNow>
            </div>
           
          </GridImage>
        </GridHEading>
        <ImageContainer>
          <VideoBK src={mainimg} />
        </ImageContainer>
      </Container>
    </SectionMainWrapper>
  );
};

export default Section1_Header;
